import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewmemberService {
 birthday = null;
newbirthday = new BehaviorSubject(null);
constructor() { }

setBirthday(day) {
  this.birthday = day;
}

}
